
import React from 'react';

import Repos from './Repos';

export default () => (
  <div>
    <p>
      There is a service called Chamber Master that
        works with business organizations (a city's chamber of commerce, for example).
      They manage the information of the member businesses of those organizations.
      Information about those businesses include
        business name, phone number, street address, website, etc.
      This information can be viewed online by everyone.
    </p>

    <hr />

    <p>
      This service doesn't have an API.
      I built a scraper to extract the information from this service and
        transform the data to JSON format.
      Having this data in JSON format makes it easy to manipulate and filter this data.
      For example, I can easily write a script to see all businesses that don't have a website.
    </p>

    <hr />

    <p>
      <Repos repos={[{
        href: 'https://github.com/michael-software-engr/',
        text: 'TODO'
      }]} />
    </p>

    Stack:
    <ul>
      <li><a href="https://www.ruby-lang.org/en/">Ruby</a></li>
      <li><a href="http://rspec.info/">RSpec</a></li>
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/Extractor.js